const t = Object.freeze({
  home: 33300,
  rota: 33301,
  chat: 33302,
  "admin-recruitment": 33303,
  recruitment: 33304
});
function r() {
  const e = window.location.hostname.toLowerCase().split(".", 1);
  switch (e[0] ?? "") {
    case "homeportal":
    case "rota":
    case "messaging":
    case "recruitment":
    case "recruitment-admin":
      return e[0];
    case "home":
      return "homeportal";
    case "admin-recruitment":
      return "recruitment-admin";
    case "chat":
      return "messaging";
    default:
      return window.location.hostname.toLowerCase();
  }
}
function a(e) {
  return import.meta.env.VITE_URL_BASE ? `https://${e}.${import.meta.env.VITE_URL_BASE}` : `https://coactive.vagrant.switchsys.dev:${t[e]}`;
}
export {
  r as a,
  a as g
};
